import { render, staticRenderFns } from "./apex_horizontal_bar_chart.vue?vue&type=template&id=34cf6215&"
import script from "./apex_horizontal_bar_chart.vue?vue&type=script&lang=js&"
export * from "./apex_horizontal_bar_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports